/* eslint-disable indent */
import {
  EmailReminderSendNow,
  EmailReminderTriggerType,
} from '@/api/entities/email-reminder';
import { getLanguage } from '@/utils/language.utils';
import { TFunction } from 'i18next';

const getDayAbbreviation = () => {
  const { languageCode } = getLanguage();
  switch (languageCode) {
    case 'fr':
      return 'J';
    case 'en':
      return 'Day';
    default:
      return 'Day';
  }
};

export const getTriggerOptions = (t: TFunction<undefined>) => {
  const daysOptions = [];
  const dayAbbreviation = getDayAbbreviation();

  for (let i = -10; i <= 10; i++) {
    daysOptions.push({
      label: i < 0 ? `${dayAbbreviation}${i}` : `${dayAbbreviation}+${i}`,
      value: `${i}`,
    });
  }

  const daysOptionsWithNow = [
    {
      label: t('common:now'),
      value: EmailReminderSendNow.NOW,
    },
    ...daysOptions,
  ];

  return daysOptionsWithNow;
};

export const getConditionOptions = (t: TFunction<undefined>) => {
  return [
    {
      label: t('common:allConditions'),
      value: EmailReminderTriggerType.ALL,
    },
    {
      label: t('common:inspectionNotStarted'),
      value: EmailReminderTriggerType.INSPECTION_NOT_STARTED,
    },
    {
      label: t('common:inspectionCompleted'),
      value: EmailReminderTriggerType.INSPECTION_COMPLETED,
    },
  ];
};
